import Vue from 'vue'
import App from '@/App.vue'
import mixins from '@/mixins'
import router from '@/router'
import store from '@/store'

import '@/lib/axios'
import '@/lib/font'
import '@/lib/bootstrap'
import '@/lib/icons'

Vue.config.productionTip = false

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app')